import {SecurityQuestions, UserApiService} from '@/services/generated/edge/user';

export function loadSecurityQuestions(store): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    UserApiService.getSecurityQuestions().then((response: SecurityQuestions) => {
      store.state.securityQuestions = <any>response.securityQuestions;
      resolve();
    }).catch((error) => {
      reject();
      this.handleApiError(error);
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils.ts